/*******************************************
 *  This file contains all the properties that the configuration should have with their defaults;
 *  If a new environment arises make a copy an name accordingly.
 *******************************************/
 export const environment = {
  production: false,
  region: '',
  baseURL: '',
  gatewayURL: 'https://dev-app.tcc.tenncare.tn.gov/',
};